import { TIMEOUT_TIME, STAGE_DIRNAME, VARIANTS_PER_PORTAL, BASE_PATH_API_DEV, BASE_PATH_API } from 'constants/general';
import axios from 'axios';
import { decodeStorage } from 'pages/Header/Content/functions/storageBase64';

export async function getVerificarCreditoCS(token) {

    const access_token = decodeStorage('access_token');
    let apiURL;
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.serviceOptim}/app/v1/claroshop-credit?token=${token}`;
    }else{
        apiURL = `${BASE_PATH_API}/app/v1/claroshop-credit?token=${token}`;
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${access_token}`
        }
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
        })
        .catch(error => {
            // console.log(error)
            // console.log(error.request)
            // console.log(error.response)
            // console.log(error.response.data)
            return (
                {
                    'headers': '',
                    'statusCode': error.request.status,
                    'data': error.request.response,
                    'error': error.response?.data.msg

                })
        })
}

export async function postVerificaAceptacionCredito(dataVerificacion, token){
    let apiURL
    const access_token = decodeStorage('access_token')
    // console.log(" data: ", dataVerificacion, " token: ", token)
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.serviceOptim}/app/v1/claroshop-credit\?token\=`+ token
    }else{
        apiURL = `${BASE_PATH_API}/app/v1/claroshop-credit\?token\=`+ token;
    }

    const raw = dataVerificacion

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        },
        data: raw
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export async function getVerificarPhone(token) {

    const access_token = decodeStorage('access_token');
    let apiURL;
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.serviceOptim}/app/v1/claroshop-credit?token=${token}`;
    }else{
        apiURL = `${BASE_PATH_API}/app/v1/claroshop-credit?token=${token}`;
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${access_token}`
        }
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
        })
        .catch(error => {
            // console.log(error)
            // console.log(error.request)
            // console.log(error.response)
            // console.log(error.response.data)
            return (
                {
                    'headers': '',
                    'statusCode': error.request.status,
                    'data': error.request.response,
                    'error': error.response?.data.msg

                })
        })
}

export async function getEnviarOTP(token, medio) {

    const access_token = decodeStorage('access_token');
    let apiURL;

    let nedioSend = medio === 'whatsapp' ? `&template=registry&canal=whatsapp` : ''

    if (STAGE_DIRNAME === 'dev') {
        apiURL = `${BASE_PATH_API_DEV.serviceOptim}/app/v1/sms-notification?token=${token}${nedioSend}`;
    } else {
        apiURL = `${BASE_PATH_API}/app/v1/sms-notification?token=${token}${nedioSend}`;
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${access_token}`
        }
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
        })
        .catch(error => {
            // console.log(error)
            // console.log(error.request)
            // console.log(error.response)
            // console.log(error.response.data)
            return (
                {
                    'headers': '',
                    'statusCode': error.request.status,
                    'data': error.request.response,
                    'error': error.response?.data.msg

                })
        })
}